export const state = getInitialState();

export function getInitialState() {
  return {
    show: false,
    text: null
  };
}
